module.exports = __webpack_public_path__ + "img/temp.ab7df9ce.svg";